import UIButton from 'UIComponents/button/UIButton';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NoWAAccount(props) {
  const {
    isAdmin,
    inboxId
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center",
    style: {
      padding: 70
    },
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'composer-ui.whatsapp.noWAAccount.title'
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        marginTop: 16,
        paddingLeft: 30,
        paddingRight: 30
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isAdmin ? 'composer-ui.whatsapp.noWAAccount.infoAdmin' : 'composer-ui.whatsapp.noWAAccount.infoUser'
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        marginTop: 32
      },
      children: isAdmin && /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        target: "_blank",
        href: `${getFullUrl('app')}/live-messages-settings/${PortalIdParser.get()}/inboxes/${inboxId}/whats-app/create`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'composer-ui.whatsapp.noWAAccount.adminLabel'
        })
      })
    })]
  });
}
NoWAAccount.displayName = 'NoWAAccount';